const EmberSubagents = ['regulatory_expert', 'consumption_expert', 'procurement_expert', 'visualization_expert']

export const isEmberSubagent = (name: string): boolean => EmberSubagents.includes(name)
